import mitt from 'mitt';
const emitter = mitt();
emitter.once = (type, handler) => {
  const fn = (arg) => {
    emitter.off(type, fn);
    handler(arg);
  };

  emitter.on(type, fn);

  // return this handler
  return fn;
};
// emitter.on('*', (event) => {
//   console.log('EVENT: ', event);
// });
export default emitter;
